import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

const propTypes = {
  data: PropTypes.array.isRequired,
};

export default function Results(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { data } = props;

  return (
    <table>
      <thead>
        <tr>
          <td>
            <strong>Name</strong>
          </td>
          <td>
            <strong>Firm Name/Details</strong>
          </td>
          <td>
            <strong>Able to work in the following law types</strong>
          </td>
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <tr key={row.key}>
            <td>{row.name}</td>
            <td>
              {row.firm} <br/>
              {row.number} <br/>
              {row.city} <br/>
            </td>
            <td>
              <ul>
                {row.searchResults.map((value) => (
                  <li key={value}>{value}</li>
                ))}
              </ul>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
Results.propTypes = propTypes;
